//#region src/variants/variants_input_group.js
var variants_input_group_default = { default: {
	props: {
		name: { initialValue: "fruits-input-group" },
		legend: { initialValue: "Fruits" }
	},
	slots: { default: { initialValue: "<dt-radio value=\"apple\"><span>Apple</span></dt-radio><dt-radio value=\"banana\"><span>Banana</span></dt-radio><dt-radio value=\"other\"><span>Other</span></dt-radio>" } }
} };
//#endregion
export { variants_input_group_default as default };

//# sourceMappingURL=variants_input_group.js.map